export const modularHousesNavItems = {
  model: 'Model 3D',
  options: 'Opcions',
};

export const description =
  `Les cases modulars ofereixen un disseny inusual i una vida còmoda per a la seva família. L'acollidora Càceres, el romàntic Toledo o la dinàmica Barcelona, aquest tipus d'allotjament encaixa fàcilment en qualsevol paisatge. Produïm edificis modulars moderns, energèticament eficients i prefabricats. El seu habitatge, completament preparat per a la residència permanent, tindrà en compte totes les seves necessitats. Se li dona l'oportunitat de triar l'opció amb un acabat interior clau en mà.`;